import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type RecurringLiveEventContentCardFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, startTime: string, status: Types.ResourceStatusEnum, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null } | {} | null, performance?: { id: string, status: Types.PerformanceStatusEnum, progress: number, estimatedTimeSpent?: number | null } | null };


export type RecurringLiveEventContentCardFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type RecurringLiveEventContentCardWithUserPerformanceFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, startTime: string, status: Types.ResourceStatusEnum, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null } | {} | null, performance?: { id: string, status: Types.PerformanceStatusEnum, progress: number, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null };


export type RecurringLiveEventContentCardWithUserPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const RecurringLiveEventContentCardFragmentDoc = /*#__PURE__*/ gql`
    fragment RecurringLiveEventContentCard on RecurringLiveEventContentType {
  id
  name
  type
  duration
  description
  startTime
  status
  cover {
    ...EntityMedia
  }
  event {
    ... on RecurringLiveEventType {
      id
      status
      recurringCategory
    }
  }
  performance {
    id
    status
    progress
    estimatedTimeSpent
  }
}
    `;
export const RecurringLiveEventContentCardWithUserPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment RecurringLiveEventContentCardWithUserPerformance on RecurringLiveEventContentType {
  id
  name
  type
  duration
  description
  startTime
  status
  cover {
    ...EntityMedia
  }
  event {
    ... on RecurringLiveEventType {
      id
      status
      recurringCategory
    }
  }
  performance(userId: $userId) {
    id
    status
    progress
    estimatedTimeSpent
    enrolmentInfo {
      dueDate
    }
  }
}
    `;